import { makeStyles, mergeClasses } from '@griffel/react';

import { Fluent9ComponentClassNames } from '../../../../util/classNames';
import { createTokens } from '../../../../util/theme/fluent9';

const { tokens, cssVariables } = createTokens(['backgroundImage'], 'appLayout-mainAreaHeroBackground');

interface GetInlineStylesProps {
  readonly imgSrc?: string;
}
export const getInlineStyles = ({ imgSrc }: GetInlineStylesProps) => ({
  [cssVariables.backgroundImage]: imgSrc ? `url(${imgSrc})` : undefined,
});

interface UseClassNamesProps {
  readonly isWide: boolean;
}
type UseClassNames = ({ isWide }: UseClassNamesProps) => Fluent9ComponentClassNames<'mainAreaHeroBackground'>;
export const useClassNames: UseClassNames = ({ isWide }) => {
  const mainAreaHeroBackgroundClasses = useMainAreaHeroBackgroundClasses();

  return {
    mainAreaHeroBackground: mergeClasses(
      mainAreaHeroBackgroundClasses.mainAreaHeroBackground,
      isWide && mainAreaHeroBackgroundClasses.mainAreaHeroBackgroundImage
    ),
  };
};

const useMainAreaHeroBackgroundClasses = makeStyles({
  mainAreaHeroBackground: {
    width: '100%',
    height: '100%',
  },
  mainAreaHeroBackgroundImage: {
    backgroundImage: tokens.backgroundImage,
    backgroundPositionX: 0,
    backgroundPositionY: 0,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
  },
});
